import { Flex, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import ReleaseIcon from '@/assets/scope-info-disable.svg?react'

const tips = [{ key: 'release', icon: <ReleaseIcon className="shrink-0" /> }] as const
export default function ScopeInfoCard() {
  const { t } = useTranslation()

  return (
    <div
      style={{
        background: 'rgba(0, 0, 0, 0.04)',
        borderRadius: 8,
        padding: '14px 20px',
        marginBottom: 20,
        display: 'flex',
        flexDirection: 'column',
        gap: 14,
      }}
    >
      <Flex align="center" gap={6}>
        <span
          style={{
            width: 2,
            height: 14,
            background: '#6366F1',
            borderRadius: 1,
            flexShrink: 0,
          }}
        />
        <Typography.Text style={{ fontSize: 16, fontWeight: 500, lineHeight: '24px' }}>
          {t('scope.infoLead')}
        </Typography.Text>
      </Flex>

      <Flex vertical gap={8}>
        {tips.map(({ key, icon }) => (
          <Flex key={key} align="center" gap={8}>
            {icon}
            <Typography.Text style={{ fontSize: 13, lineHeight: '20px', whiteSpace: 'nowrap' }}>
              · {t(`scope.info_${key}_title`)}
            </Typography.Text>
            <Typography.Text
              style={{
                fontSize: 13,
                lineHeight: '20px',
                color: 'rgba(0, 0, 0, 0.6)',
                flex: 1,
              }}
            >
              {t(`scope.info_${key}_desc`)}
            </Typography.Text>
          </Flex>
        ))}
      </Flex>
    </div>
  )
}
